import { useNavigate } from "react-router-dom";
import { logout } from "../common/api/auth";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { useState } from "react";

function Topbar() {
  const navigate = useNavigate();
  const [showLogout, setShowLogout] = useState(false);
  const { isLoggedIn, setIsLoggedIn } = useContext(AuthContext);

  const handleLoginLink = () => {
    if (!isLoggedIn) {
      navigate("/login");
    } else {
      setShowLogout(!showLogout);
    }
  };


  const handleConfirmLogout = () => {
    logout();
    setIsLoggedIn(false);
    navigate("/login");
  };

  return (
    <div className="sup_nav">
      <div className="nav_log">
        <img className="logo" src="/logo.svg" alt="logotipo" />
        {/*<span className="boton_opciones">Connect</span>
        <span className="boton_cancelar">Disconnect</span>*/}
      </div>

      <div className="nav_perfil" style={{ position: "relative" }}>
        {/*<span className="boton_cancelar">Hide/Show Log</span>*/}
        <i className="bi bi-escape icon-link" onClick={handleLoginLink}></i>

        {isLoggedIn && showLogout && (
          <div className="logout-popup" onClick={handleConfirmLogout}>
            Cerrar sesión
          </div>
        )}
      </div>
    </div>
  );
}

export default Topbar;
